import { useMemo } from "react";
import analyticsService from "../AnalyticsService";
import * as analyticsEvents from "../events";

export const useAnalytics = () => {
  return useMemo(
    () => ({
      ...analyticsEvents,
      trackPageView: analyticsEvents.trackPageView,
      trackClick: analyticsEvents.trackClick,
      trackError: analyticsEvents.trackError,
      trackDownload: analyticsEvents.trackDownload,
      trackDashboard: analyticsEvents.trackDashboard,
      trackCard: analyticsEvents.trackCardInteraction,
      service: analyticsService,
    }),
    [],
  );
};

export default useAnalytics;
